import { ListItemText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import { WithSnackbarProps } from 'notistack';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectedFileList: {
      border: `1px solid ${theme.palette.divider}`
    },
    subheader: { 
      marginBottom: 16 
    },
    chooseFileButton: { 
      minWidth: 130, 
      marginRight: 16 
    },
    errorText: { 
      marginTop: 4 
    },
    hiddenFileInput: { 
      display: "none" 
    }
  })
);

interface Props {
  file: File;
  showFormErrors: boolean;
  onFileChange: (file: File) => void;
}

function FileUploadForm(props: Props & RouteComponentProps<any> & WithSnackbarProps) {
  const { file, showFormErrors, onFileChange } = props;
  const classes = useStyles({});

  return (
    <div>
      <div>
        <Typography variant="subtitle1">Upload Test Package</Typography>
        <Typography variant="caption" display="block" className={classes.subheader}>Must be a zip file with at least one python file at the root</Typography>

        <div>
          {!file && <Button
            className={classes.chooseFileButton}
            variant="outlined"
            component="label"
          >
            Choose file
          <input
              type="file"
              accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
              className={classes.hiddenFileInput}
              onChange={(event) => onFileChange(event.target.files[0])}
            />
          </Button>}
          {showFormErrors && !file && <Typography className={classes.errorText} color="error" variant="caption" display="block">Test package is required</Typography>}
        </div>
      </div>
      {file && <List className={classes.selectedFileList}>
        <ListItem>
          <ListItemText
            primary={file.name}
          />
          <ListItemSecondaryAction>
            <IconButton edge="end" aria-label="delete" onClick={() => onFileChange(null)}>
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>}
    </div>
  );
};

export default FileUploadForm;
